import { useState, useRef } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION } from "../../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../../Utils/Exception";

const InvoiceReceiptSeriesController = (onRefresh,toggleReceiptSeries) => {
    const [deleteLoading, setDeleteLoading] = useState({});
    const [deleteError, setDeleteError] = useState({});
    const [deleteSuccess, setDeleteSuccess] = useState({});
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const { setIsLoginPopup } = useTheme();
    const pageName ="InvoiceReceiptSeriesController"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    const handleEdit = (item) => {
        console.log("Edit item:", item);
        // Implement edit logic here
    };

    const handleDeleteServiceType = (service) => {
        setSelectedReceipt(service);
        setIsDeleteModalOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false); // Close the modal
    };

    const callDeleteServiceType = async (service) => {
        try {
            setDeleteError({});
            setDeleteError((prev) => ({ ...prev, [service?.series_id]: '' }));
            setDeleteLoading((prev) => ({ ...prev, [service?.series_id]: true }));
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "action": "RECEIPT_SERIES_DELETE",
                "emp_id_auth": storedUserInfo?.emp_id,
                "series_id": service?.series_id,
            }

            //console.log('callDeleteServiceType payload',payLoad);

            // Make the API call
            const response = await postData(ORG_CONFIGURATION, payLoad);
            const responseData = await response.json();
            //console.log('callDeleteServiceType response Data',responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setDeleteSuccess((prev) => ({ ...prev, [service?.series_id]: responseData?.info }));
                        setTimeout(() => {
                            setDeleteSuccess((prev) => ({ ...prev, [service?.series_id]: '' }));
                            onRefresh();
                            toggleReceiptSeries();
                        }, 3000);
                    } else {
                        setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Failed to delete service. Please try again.' }));
                        logFrontendException(storedUserId, pageName, "callDeleteServiceType", responseData?.info || '');
                    }
                } else {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Failed to delete service. Please try again...' }));
                    logFrontendException(storedUserId, pageName, "callDeleteServiceType", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
                    logFrontendException(storedUserId, pageName, "callDeleteServiceType", response || '');
                } else {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Bad request. Please check the request parameters.' }));
                    logFrontendException(storedUserId, pageName, "callDeleteServiceType", response || '');
                    
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            
            // Unexpected or network-related errors
            else {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: 'Unexpected error occurred. Please try again later.' }));
                logFrontendException(storedUserId, pageName, "callDeleteServiceType", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: `Failed to delete service data. Please check your network connection and try again.` }));
                logFrontendException(storedUserId, pageName, "callDeleteServiceType-catch", error || '');
            
        } finally {
            setDeleteLoading((prev) => ({ ...prev, [service?.series_id]: false }));
        }
    }

    return {
        deleteLoading,
        deleteError,
        deleteSuccess,
        handleEdit,
        handleDeleteServiceType,
        callDeleteServiceType,
        isDeleteModalOpen,
        selectedReceipt,
        handleCloseDeleteModal,
    };
};

export default InvoiceReceiptSeriesController;
